import React, { Component } from 'react';
import styled from 'styled-components';
export const InputStyle = styled.input `
  padding: 12px 8px 11px;
  border-radius: 2px;
  font-size: ${(props) => props.theme.fontMedium};
  line-height: 21px;
  color: ${(props) => props.theme.navyBlue};
  outline: none;
  box-sizing: border-box;
  background: ${(props) => props.theme.blackSqueeze};
  border: 1px solid
    ${(props) => (props.invalid ? props.theme.red : props.theme.lightGray)};
  background-clip: padding-box;
  appearance: none;
  @media ${(props) => props.theme.md} {
    padding: 7px 8px 6px;
    font-size: ${(props) => props.theme.fontSmall};
  }
  &:focus {
    border: 1px solid ${(props) => props.theme.blue};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    background: ${(props) => props.theme.lightGray};
  }

  ${(props) => props.autoFilled && `background: ${props.theme.lightBlue}`};
`;
class StandardInput extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(InputStyle, Object.assign({ onInvalid: (e) => {
                if (e.target) {
                    e.target.scrollIntoView(false);
                }
            }, ref: this.props.inputRef }, this.props)));
    }
}
export default StandardInput;
